/**
 * Accordion Module
 * アコーディオン機能
 */
export class Accordion {
  constructor() {
    this.accordions = document.querySelectorAll('.js-accordion');
    this.eventHandlers = new Map();
    this.PADDING_BUFFER = 100; // padding分の余裕
    
    if (this.accordions.length > 0) {
      this.init();
    }
  }
  
  init() {
    this.accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('.js-accordion__trigger');
      const content = accordion.querySelector('.js-accordion__content');
      
      if (!trigger || !content) {
        return;
      }
      
      this.setupAccordion(accordion, trigger, content);
    });
  }
  
  /**
   * アコーディオンの設定
   */
  setupAccordion(accordion, trigger, content) {
    const clickHandler = (e) => {
      e.preventDefault();
      this.toggleAccordion(accordion, content);
    };
    
    trigger.addEventListener('click', clickHandler);
    this.eventHandlers.set(accordion, [{ event: 'click', handler: clickHandler, element: trigger }]);
  }
  
  /**
   * アコーディオンの開閉を切り替え
   */
  toggleAccordion(accordion, content) {
    const isOpen = accordion.classList.contains('is-open');
    
    if (isOpen) {
      this.close(accordion, content);
    } else {
      this.open(accordion, content);
    }
  }
  
  /**
   * アコーディオンを開く
   */
  open(accordion, content) {
    accordion.classList.add('is-open');
    content.style.maxHeight = 'none';
    
    requestAnimationFrame(() => {
      const height = content.scrollHeight + this.PADDING_BUFFER;
      content.style.maxHeight = '0px';
      
      requestAnimationFrame(() => {
        content.style.maxHeight = `${height}px`;
      });
    });
  }
  
  /**
   * アコーディオンを閉じる
   */
  close(accordion, content) {
    const currentHeight = content.scrollHeight + this.PADDING_BUFFER;
    content.style.maxHeight = `${currentHeight}px`;
    
    requestAnimationFrame(() => {
      accordion.classList.remove('is-open');
      content.style.maxHeight = '0px';
    });
    
    // アニメーション完了後にスタイルをクリア
    const handleTransitionEnd = (e) => {
      if (e.target === content && e.propertyName === 'max-height' && !accordion.classList.contains('is-open')) {
        content.style.maxHeight = '';
        content.removeEventListener('transitionend', handleTransitionEnd);
      }
    };
    
    content.addEventListener('transitionend', handleTransitionEnd, { once: true });
  }
  
  /**
   * イベントリスナーを削除
   */
  destroy() {
    this.accordions.forEach((accordion) => {
      const handlers = this.eventHandlers.get(accordion);
      if (handlers) {
        handlers.forEach(({ event, handler, element }) => {
          element.removeEventListener(event, handler);
        });
        this.eventHandlers.delete(accordion);
      }
    });
  }
}
